import React, { useState, useEffect } from "react";
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import { STabs } from '@avalara/skylab-sdk/react';
import ManualDocumentsForm from "../filing/manualDocuments/ManualDocumentsForm";

import { connect } from "react-redux";
import ApplicationMessages from "../inAppMessages/ApplicationMessages";
import Logger, {ALL_MESSAGES, LOG_LEVELS} from "../../utils/logger";
import moment from "moment/moment";
import {closeHandler} from "../inAppMessages/messagesHelper";
import {ApplicationMessagesIcons} from "../inAppMessages/ApplicationMessagesIcons";
import {Link} from "react-router-dom";
import {SDashAlertCloseButton} from "../helper/sdash-pollyfills";
import MANUAL_DOCUMENTS_CONTROLLER from "../../controllers/manualDocuments";
import EnhancedVatReturns from "./EnhancedVatReturns";
import TabContainer from "./tabs/TabContainer";
import ConfirmationModal from "../modals/ConfirmationModal";

const log = new Logger('MANUAL_DOCUMENTS_PAGE', LOG_LEVELS.DEBUG);
const REFERENCE_REPORTER_LIMIT = 62;

const ManualDocuments = (props) => {
    const tabItems = [
        {
            id: 'vat-return',
            label: 'VAT Return',
            featureFlag:'EnableVatReturnManualDocument',
            tabPanelId: 'panel-vat-return',
            selected: false
        },
        {
            id: 'ec-listing',
            label: 'EC Listing',
            featureFlag: 'EnableEcListingManualDocument',
            tabPanelId: 'panel-ec-listing',
            selected: false
        },
        {
            id: 'intrastat',
            label: 'Intrastat',
            featureFlag: 'EnableIntrastatManualDocument',
            tabPanelId: 'panel-intrastat',
            selected: false
        }
    ];

    const [activeTab, setActiveTab] = useState('');
    const [selectedValues, setSelectedValues] = useState({});
    const [invoiceDate, setInvoiceDate] = useState('');
    const [tabList, setTabList] = useState({data: tabItems});
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [currentTabEvent, setCurrentTabEvent] = useState({ data: {}})
    
    const mandatoryFields = ['companyCode', 'country', 'currency', 'transactionDate', 'invoiceDate'];

    useEffect(() =>{
        if(props.featureFlags?.EnableVatReturnManualDocument) {
            setActiveTab('vat-return');
        } else if (props.featureFlags?.EnableEcListingManualDocument) {
            setActiveTab('ec-listing');
        } else if (props.featureFlags?.EnableIntrastatManualDocument) {
            setActiveTab('intrastat');
        }
        props.doResetDocumentDetails();
    },[])

    useEffect(() => { 
        const updatedTabList = tabList.data.map(obj => ({
            ...obj,
            selected: obj.id === activeTab
        }));
        setTabList({data: updatedTabList})
    },[activeTab]);

    const defaultFormProps = {
        hideTransactionType: false,
        hideSubmissionButton: true,
        enableCompany: true,
        enableCountry: true,
        hideManualDocumentType: true,
        hideTypeOfReturnTitle: true,
        dateClearance: true,
        showRequiredFields: true,
        referenceReporterLimit: REFERENCE_REPORTER_LIMIT
    }

    const getEnabledTabs = () => {
        let response = []
        for(let tab in tabList.data) {
            if(props?.featureFlags[tabList.data[tab].featureFlag] !== undefined && props?.featureFlags[tabList.data[tab].featureFlag] === true){
                response.push(tabList.data[tab]);
            }
        }
        return response;
    }

    const areAllMandatoryFieldsSelected = (selection) => {
        return mandatoryFields.every((field) => selection[field] !== undefined && selection[field] !== '');
    };
    
    const onTabSelection = (tabDetails) => {
        // Prevent duplicate triggers while modal is already open
        if (showConfirmationModal) {
            return;
        }
        if (activeTab !== tabDetails.id) {
            // Keep current selection; just stage the new tab and show modal once
            setCurrentTabEvent({ data: tabDetails, previousTab: activeTab });
            setShowConfirmationModal(true);
        } else {
            setActiveTab(tabDetails.id);
        }
    }
    
    const onAcceptConfirmationModal = () => {
        const {data} = currentTabEvent;
        setActiveTab(data.id);
        // Set tabList as per it's status - to select active tab
        setterForTabList(data.id);
        setShowConfirmationModal(false);
    }

    const onCancelConfirmationModal = () => {
        const {previousTab} = currentTabEvent;
        // Skylab - Don't provide any event to dis-select tab, hence when user click on tab it's state set's to true and that's why we need to update state and re-render it
        // Set tabList as per it's status - to select active tab
        setterForTabList(previousTab);
        setActiveTab(previousTab);
        setShowConfirmationModal(false);
    }
    
    const setterForTabList = (id) => {
        const updatedTabList = tabList.data.map(obj => ({
            ...obj,
            selected: obj.id === id
        }));
        const temp = {data: updatedTabList}
        setTabList({...temp})
    }

    const renderActivePanel = () => {
        switch (activeTab) {
            case 'vat-return':
                return props.featureFlags?.EnableVatReturnManualDocument && (
                    <div id="panel-vat-return" role="tabpanel" aria-labelledby="vat-return" tabIndex="0" className="mb20">
                        <EnhancedVatReturns selectedValues={selectedValues} />
                    </div>
                )
            case 'ec-listing':
                return props.featureFlags?.EnableEcListingManualDocument && <div id="panel-ec-listing" role="tabpanel" aria-labelledby="ec-listing" tabIndex="1"><TabContainer selectedValues={selectedValues} activeTab={activeTab} for={"ecListing"} invoiceDate={invoiceDate}/></div>;
            case 'intrastat':
                return props.featureFlags?.EnableIntrastatManualDocument && <div id="panel-intrastat" role="tabpanel" aria-labelledby="intrastat" tabIndex="2"><TabContainer selectedValues={selectedValues} activeTab={activeTab} for={"intrastat"} invoiceDate={invoiceDate}/></div>;
            default:
                return null;
        }
    };

    const handleSelection = (values) => {
        if (values['companyCode'] === 'All') {
            delete values['companyCode'];
        }
        
        // Extract and set invoiceDate separately to ensure it triggers rerenders
        if (values.invoiceDate !== undefined) {
            setInvoiceDate(values.invoiceDate);
        }

        setSelectedValues(values);  
    }
   
    const renderFileDetails = () => {
        const documentDetails = props?.documentDetails;
        const tomorrow  = moment(new Date()).add(1,'days').format('YYYY-MM-DD');
        const enableUploadedDocumentsPage = props.featureFlags?.EnableUploadedDocumentsPage;
    
        // check of we recieve an empty object in documentDetails
        if (documentDetails && typeof(documentDetails) === 'object' && Object.keys(documentDetails).length === 0) {
            return (
                <s-alert status="error" role="alert" data-testid="file-details-error-msg">
                    <ApplicationMessagesIcons messageStatus="error"/>
                    <div style={{ color: 'red' }}>Error Occurred while storing the Manual Document. Please retry after sometime.</div>
                </s-alert>
            );
        }
  
        return documentDetails && documentDetails.map(f => {
            const fileName = f.fileName;
            return <s-alert key={f.id} status="success" role="alert" data-testid="file-details-success-msg" s-dismiss={closeHandler(f, log)}>
                <ApplicationMessagesIcons messageStatus="success"/>
                {enableUploadedDocumentsPage
                    ? <Link to={`/uploadedDocuments?endDate=${tomorrow}&filename=${fileName}`}>
                        <LanguageStringResolver string="manual_document_file_success_message" tooltip="manual_document_file_success_message_tooltip" tooltipWithParams={true} params={fileName} />
                        <SDashAlertCloseButton onClose={closeHandler(f, log)}/>
                      </Link>
                    : <Link to={`/ProcessedDocuments?endDate=${tomorrow}&filename=${fileName}`}>
                        <LanguageStringResolver string="manual_document_file_success_message" tooltip="manual_document_file_success_message_tooltip" tooltipWithParams={true} params={fileName} />
                        <SDashAlertCloseButton onClose={closeHandler(f, log)}/>
                      </Link>
                }
            </s-alert>
        });
    }

    return (
        <>
            <s-container class="mb50">
                <div className="content-area">
                    <h1>
                        <LanguageStringResolver string="PageName_ManualDocuments"/>
                    </h1>
                    <ApplicationMessages
                        messageIds={[
                            ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_NO_FILE_DATA
                        ]}
                        messageType="applicationError"
                    />
                    {renderFileDetails()}
                    <ManualDocumentsForm
                        {...defaultFormProps}
                        initData={{
                            reporterName: props.userName,
                            updateCurrencyAsCountry: true,
                        }}
                        onSelection={handleSelection}
                    />
                    {areAllMandatoryFieldsSelected(selectedValues) &&
                        <>
                            <STabs
                                data-testid="return-type-tabs"
                                tabItems={getEnabledTabs()}
                                onS-select={e => onTabSelection(e.detail)}>
                            </STabs>
                            {renderActivePanel()}
                        </>
                    }
                </div>
                <ConfirmationModal dataTestId="manual-document"
                                   isModalPopupOpen={showConfirmationModal}
                                   modelTitle = "manual_document_confirmation_title"
                                   modelMessage = "manual_document_confirmation_message"
                                   onYesClickHandler = {() => onAcceptConfirmationModal()}
                                   onCancelClickHandler = { () => onCancelConfirmationModal()}
                />
            </s-container>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        userName: state.authentication?.data?.userName || "Unknown",
        featureFlags: state.featureFlag && state.featureFlag.data,
        documentDetails: state.manualDocuments && state.manualDocuments.documentDetails
    };
}

const mapDispatchersToProps = dispatch => {
    return {
        doResetDocumentDetails: () => {
            dispatch(MANUAL_DOCUMENTS_CONTROLLER.doResetDocumentDetails())
        }
    }
}

export default connect(mapStateToProps, mapDispatchersToProps)(ManualDocuments);